import { render, staticRenderFns } from "./View.vue?vue&type=template&id=496c0755&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&id=496c0755&prod&lang=css&"
import style1 from "./View.vue?vue&type=style&index=1&id=496c0755&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c0755",
  null
  
)

export default component.exports